import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { value: 'en', label: 'English', code: 'US' },
    { value: 'ro', label: 'Română', code: 'RO' },
    { value: 'es', label: 'Español', code: 'ES' }
  ];

  const currentLanguage = languages.find(lang => lang.value === language) || languages[0];

  const FlagDisplay = ({ code }: { code: string }) => {
    switch (code) {
      case 'US':
        return (
          <div className="relative w-6 h-4 rounded border overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-b from-red-600 via-red-600 to-red-600"></div>
            <div className="absolute inset-0 bg-gradient-to-b from-red-600 via-white via-red-600 to-white" style={{
              background: 'repeating-linear-gradient(to bottom, #dc2626 0px, #dc2626 2px, #ffffff 2px, #ffffff 4px)'
            }}></div>
            <div className="absolute top-0 left-0 w-3 h-2 bg-blue-700"></div>
          </div>
        );
      case 'RO':
        return (
          <div className="w-6 h-4 rounded border overflow-hidden flex">
            <div className="flex-1 bg-blue-600"></div>
            <div className="flex-1 bg-yellow-400"></div>
            <div className="flex-1 bg-red-600"></div>
          </div>
        );
      case 'ES':
        return (
          <div className="w-6 h-4 rounded border overflow-hidden">
            <div className="h-1 bg-red-600"></div>
            <div className="h-2 bg-yellow-400"></div>
            <div className="h-1 bg-red-600"></div>
          </div>
        );
      default:
        return (
          <div className="w-6 h-4 rounded border bg-muted flex items-center justify-center">
            <span className="text-xs text-muted-foreground">{code}</span>
          </div>
        );
    }
  };

  return (
    <Select value={language} onValueChange={(value: 'en' | 'ro' | 'es') => setLanguage(value)}>
      <SelectTrigger className="w-auto min-w-[120px] bg-background/80 backdrop-blur-sm border-border/50">
        <div className="flex items-center gap-2">
          <FlagDisplay code={currentLanguage.code} />
          <span className="hidden sm:inline">{currentLanguage.label}</span>
          <span className="sm:hidden">{language.toUpperCase()}</span>
        </div>
      </SelectTrigger>
      <SelectContent className="bg-background/95 backdrop-blur-sm border-border/50">
        {languages.map((lang) => (
          <SelectItem key={lang.value} value={lang.value}>
            <div className="flex items-center gap-2">
              <FlagDisplay code={lang.code} />
              <span>{lang.label}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;